const winningTeamData = [
  {
    problem: "🥇 PS1 🥇",
    name: "Gringotts",
    leader: "",
    member1: "Prince Tripathi",
    member2: "Pranjal Naman",
    member3: "Piyush Kumar",
    member4: "Khushi Bansal",
    college: "NIT Raipur",
  },
  {
    problem: "🥇 PS3 (Tie) 🥇",
    name: "Navya",
    leader: "",
    member1: "Hari Acharya",
    member2: "Riya Kushwaha",
    member3: "Priyanshu Kumar Pal",
    member4: "Shrey Raj",
    college: "United institute of Technology",
  },
  {
    problem: "🥇 PS3 (Tie) 🥇",
    name: "stackunderflow",
    leader: "",
    member1: "Kristal Dsouza",
    member2: "Andre Roy",
    member3: "Aayudh Bhattacharya",
    member4: "Ria Serrao",
    college: "PES University, Bangalore",
  },
  {
    problem: "🥇 PS4 🥇",
    name: "Visionaries United",
    leader: "",
    member1: "Aviral Patel",
    member2: "Ayush Bhavsar",
    member3: "Satya Jena",
    member4: "B Deewakar Rao",
    college: "NIT Raipur",
  },
  {
    problem: "🥇 PS5 🥇",
    name: "The Cosmos",
    leader: "",
    member1: "Shivam Gupta",
    member2: "Harsh Agrawal",
    member3: "Anadi Agrawal",
    member4: "Raj Motwani",
    college: "NIT Raipur",
  },
  {
    problem: "🥇 Open Innovation 🥇",
    name: "Kirmada",
    leader: "",
    member1: "Karan Manglani",
    member2: "Shaurya Bansal",
    member3: "Arun Rathaur",
    college: "NIT Raipur",
  },
];

export default winningTeamData;
